import React from 'react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Tab, Tabs } from '@blueprintjs/core';
import PageLockHOC from 'hoc/compNull';
import { connect } from 'react-redux';
import { setMenuSelected_2, setFocusFacility } from '@redux/actions/menuAction';

import slug from 'constants/slug';
import { getOne } from 'api/cosoApi';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import CosoPanel from './CosoPanel';
import ChiTietCosoPanel from './ChiTietCosoPanel';
import FacilityeiaPanel from './FacilityeiaPanel';
import FacilitypermitPanel from './FacilitypermitPanel';
import FacilityemissionPanel from './FacilityemissionPanel';
import InspectionPanel from './InspectionPanel';
import { get } from 'lodash';
import {
  isFacilityEiaEligible,
  isFacilityPermitEligible,
  isFacilityEmissionEligible,
} from 'utils/facilityUtil';
import { IS_ENTERPRISE } from 'config';
import FacilityDevicePanel from './FacilityDevicePanel';

const HeaderContainer = styled.div``;

const mapDispatchToProps = {
  setMenuSelected_2,
  setFocusFacility,
};

const panelList = [
  {
    key: 'coso',
    title: 'Chi tiết cơ sở/dự án',
    permissionRole: 'facility.view',
  },
  {
    key: 'chitietcoso',
    title: 'Thông tin chung',
    permissionRole: 'facility.view',
  },
  {
    key: 'facilityeia',
    title: 'Hồ sơ môi trường',
    permissionRole: 'facilityeia.view',
  },
  {
    key: 'facilitypermit',
    title: 'Giấy phép',
    permissionRole: 'facilityPermit.view',
  },
  {
    key: 'facilityEmission',
    title: 'Quản lý ô nhiễm',
    permissionRole: 'facilityEmission.view',
  },
  {
    key: 'facilityDevice',
    title: 'Quản lý thiết bị',
    permissionRole: 'facilityDevice.view',
  },
];
@PageLockHOC(['facility.view'])
@connect(
  (state) => ({
    permissions: state.permissions,
    menuSelected_2: _.get(state, 'menu.menuSelected_2', null),
  }),
  mapDispatchToProps
)
export default class CosoView extends React.Component {
  static propTypes = {
    setMenuSelected_2: PropTypes.func,
    menuSelected_2: PropTypes.string,
  };

  state = {
    _idObject: '',
    isLoading: true,
    initialValue: {},
  };

  async checkValidate() {
    const _id = _.result(this.props, 'match.params._id');
    this.props.setFocusFacility(_id);
    if (_id) {
      const res = await getOne(_id);

      if (res.success) {
        this.setState(
          {
            _idObject: _id,
            isLoading: false,
            initialValue: {
              ...res.data,
              facilityeias: get(res, 'data.facilityeias').sort(
                (a, b) =>
                  new Date(b.AddedOn).getTime() - new Date(a.AddedOn).getTime()
              ),
              facilityinspections: get(res, 'data.facilityinspections').sort(
                (a, b) =>
                  new Date(b.AddedOn).getTime() - new Date(a.AddedOn).getTime()
              ),
              facilitypermits: get(res, 'data.facilitypermits').sort(
                (a, b) =>
                  new Date(b.AddedOn).getTime() - new Date(a.AddedOn).getTime()
              ),
              facilityemissions: get(res, 'data.facilityemissions').sort(
                (a, b) =>
                  new Date(b.AddedOn).getTime() - new Date(a.AddedOn).getTime()
              ),
              facilityDevices: get(res, 'data.facilityDevices').sort(
                (a, b) =>
                  new Date(b.AddedOn).getTime() - new Date(a.AddedOn).getTime()
              ),
            },
          },
          () => {
            this.forceUpdate();
          }
        );
      }
    } else {
      this.props.history.push(slug.CO_SO.LIST);
    }
  }

  updateInitialValue = (values) => {
    this.setState({
      _idObject: values._id,
      isLoading: false,
      initialValue: values,
    });
  };

  componentWillMount = async () => {
    await this.checkValidate();
  };

  getInitialValue = (keyPath, defaultValue = '') => {
    return _.result(this.state.initialValue, keyPath, defaultValue);
  };

  getEligibleStateByKey(key) {
    switch (key) {
      case 'facilityEmission':
        return isFacilityEmissionEligible(this.state.initialValue);
      case 'facilitypermit':
        return isFacilityPermitEligible(this.state.initialValue);
      case 'facilityeia':
        return isFacilityEiaEligible(this.state.initialValue);
      default:
        return true;
    }
  }

  renderPanel = (keyPanel) => {
    switch (keyPanel) {
      case 'coso': {
        return <CosoPanel initialValue={this.state.initialValue} />;
      }
      case 'chitietcoso': {
        return (
          <ChiTietCosoPanel
            initialValue={this.state.initialValue}
            callback={this.updateInitialValue}
          />
        );
      }
      case 'facilityeia': {
        return (
          <FacilityeiaPanel
            facilityId={this.state._idObject}
            dataList={this.getInitialValue('facilityeias')}
            // initialValue={this.state.initialValue}
            // callback={this.updateInitialValue}
          />
        );
      }
      case 'inspection': {
        return (
          <InspectionPanel
            facilityId={this.state._idObject}
            dataList={this.getInitialValue('facilityinspections')}
            // initialValue={this.state.initialValue}
            // callback={this.updateInitialValue}
          />
        );
      }
      case 'facilitypermit': {
        return (
          <FacilitypermitPanel
            facilityId={this.state._idObject}
            dataList={this.getInitialValue('facilitypermits')}
            // initialValue={this.state.initialValue}
            // callback={this.updateInitialValue}
          />
        );
      }
      case 'facilityEmission': {
        return (
          <FacilityemissionPanel
            facilityId={this.state._idObject}
            dataList={this.getInitialValue('facilityemissions')}
            // initialValue={this.state.initialValue}
            // callback={this.updateInitialValue}
          />
        );
      }
      case 'facilityDevice': {
        return (
          <FacilityDevicePanel
            facilityId={this.state._idObject}
            dataList={this.getInitialValue('facilityDevices')}
            // initialValue={this.state.initialValue}
            // callback={this.updateInitialValue}
          />
        );
      }

      default: {
        return <div />;
      }
    }
  };
  handleTabChange = (value) => {
    this.props.setMenuSelected_2(value);
  };

  render() {
    return (
      <div>
        {!this.state.isLoading && (
          <div>
            <HeaderContainer>
              <Row>
                <Col xs={1}>Tên cơ sở/dự án</Col>
                <Col xs={2}>{this.getInitialValue('FacilityNameFull')}</Col>
                {!IS_ENTERPRISE && (
                  <React.Fragment>
                    <Col xs={1}>Quận/Huyện</Col>
                    <Col xs={2}>{this.getInitialValue('district.Name')}</Col>
                  </React.Fragment>
                )}
              </Row>
              <Clearfix height={8} />
              <Row>
                <Col xs={1}>Điện thoại</Col>
                <Col xs={2}>{this.getInitialValue('Telephone')}</Col>
                <Col xs={1}>Ngành/Nghề</Col>
                <Col xs={2}>{this.getInitialValue('sector.Name')}</Col>
              </Row>
            </HeaderContainer>
            <Clearfix height={16} />

            <Tabs
              animate={false}
              onChange={this.handleTabChange}
              selectedTabId={
                this.props.menuSelected_2 ? this.props.menuSelected_2 : 'coso'
              }
              renderActiveTabPanelOnly={true}
              style={{ color: 'red' }}
            >
              {panelList.map((item) => {
                const isHavePermission = this.props.permissions.includes(
                  item.permissionRole
                );
                if (isHavePermission)
                  return (
                    <Tab
                      id={item.key}
                      key={item.key}
                      title={
                        <div>
                          <span>{item.title}</span>
                        </div>
                      }
                      panel={this.renderPanel(item.key)}
                    />
                  );
                else return undefined;
              })}
            </Tabs>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/index.js